<template>
  <div class="tooltip-container">
    <div class="tooltip-container__element">
      <slot name="element"></slot>
    </div>

    <div
      ref="advancedTooltip"
      class="tooltip-container__tooltip"
      :class="{ 'is-up': isUp }"
      :style="{ top: `${fromTop}px` }"
    >
      <div v-if="!isUp" class="tooltip-container__arrow-up"></div>
      <div v-if="isUp" class="tooltip-container__arrow-down"></div>
      <div class="tooltip-container__content">
        <slot name="content"></slot>
      </div>
      <hr />
      <div class="tooltip-container__footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';

const isUp = ref(false);
const fromTop = ref(50);
const advancedTooltip = ref<HTMLElement | null>(null);

onMounted(() => {
  if (advancedTooltip.value) {
    const position = advancedTooltip.value.getBoundingClientRect();
    const padding = 15;
    if (position.bottom > window.innerHeight - padding) {
      isUp.value = true;
      fromTop.value = -(position.height + padding);
      return;
    }
  }
  isUp.value = false;
});
</script>

<style scoped lang="scss">
hr {
  color: black;
  width: 100%;
  margin: 0;
}

.tooltip-container {
  position: relative;
  display: flex;
  justify-content: center;

  &__tooltip {
    background-color: white;
    position: absolute;
    z-index: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    min-width: 260px;
    visibility: hidden;
    display: flex;

    &::after {
      content: '';
      position: absolute;
      opacity: 0;
      top: -25px;
      bottom: 0;
      height: 30px;
      width: 100%;
      background: grey;
    }

    &:hover {
      display: flex;
      visibility: visible;
    }
  }

  &__element {
    &:hover {
      + {
        .tooltip-container__tooltip {
          visibility: visible;
        }
      }
    }
  }

  &__content {
    padding: 1rem 1rem;
  }

  &__footer {
    padding: 1rem 1rem;
    width: 100%;
  }

  &__arrow-up {
    top: -9px;
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #ffffff;
    bottom: -1px;
    z-index: 9999;

    .inner-arrow {
      position: relative;
      width: 0;
      height: 0;
      top: 1.5px;
      right: 10px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgb(255, 255, 255);
    }
  }

  &__arrow-down {
    bottom: -10px;
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #ffffff;
    z-index: 9999;

    .inner-arrow {
      position: relative;
      width: 0;
      height: 0;
      bottom: 11.5px;
      right: 10px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid rgb(255, 255, 255);
    }
  }
}
</style>
